// TODO: Write Number Format Here!
export default {
  'en': {
    percent: {
      style: 'percent'
    },
    decimal: {
      style: 'decimal'
    }
  },
  'ja': {
    percent: {
      style: 'percent'
    },
    decimal: {
      style: 'decimal'
    },
    hogehgoe: {
      style: 'number',
      minimumFractionDigits: 1
    }
  }
}
